import config from '../config.mjs';

export const isCountryAt = (() => {
  return config.currentCountyCode === 'AT';
})();

export const isCountryNl = (() => {
  return config.currentCountyCode === 'NL';
})();
